import * as React from "react";
import type { SVGProps } from "react";

const SvgArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={20}
    viewBox="0 0 23 20"
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd">
      <g transform="rotate(-45 14.036 .257)">
        <rect width={2} height={12} x={10.414} y={0.414} rx={1} />
        <rect
          width={12}
          height={2}
          x={0.414}
          y={10.414}
          rx={1}
          transform="matrix(-1 0 0 1 12.828 0)"
        />
      </g>
      <rect width={15} height={2} y={9} rx={1} />
    </g>
  </svg>
);
export default SvgArrow;
